/*

Class : Buying
Description : Parcours de réservation pour les services de type "vente"
Author : Franck David

*/




import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../UI/Loader'
import { LocationMarkerIcon, XCircleIcon } from '@heroicons/react/solid'
import './Services.css'
import ReactBodymovin from 'react-bodymovin'
import animation from '../../img/check-circle.json'
import Checkout from './Checkout'
import PaymentChoice from './PaymentChoice'
import tools from '../../tools'

class Buying extends Component {
	constructor(props) {
		super(props)
		this.state = {
			reservation: this.props.reservation,
			step: 0,
			curr: null,
			answers: [],
			question_nb: 0,
			user: {
				client_number: null,
				identity: null,
				age: null,
				phone: null
			},
			attempt_submit: false,
			checkout: null,
			payment_choice: false,
			stripeError: null,
			error: this._initErrors()
		}
		this.length_max = 40
		if (this.props.user.from === "dashboard")
		{
			this.state.user.client_number = 0
			this.state.user.identity = "Test Test"
			this.state.user.age = 42
			this.state.user.phone = "123456"
		}
		else
		{
			this.state.user.client_number = this.props.user.client_number
			let identity = ""
			if (this.props.user.civility && this.props.user.civility.length > 0)
			{
				if (this.props.user.civility === "femme")
					identity = "Mme. "
				else if (this.props.user.civility === "homme")
					identity = "Mr. "
			}
			identity += this.props.user.firstname + " " + this.props.user.lastname
			this.state.user.identity = identity
			let age = null
			const date = new Date()
			if (this.props.user.birthday && this.props.user.birthday.length > 0)
			{
				const day = Number(this.props.user.birthday.substr(0, 2))
				const month = Number(this.props.user.birthday.substr(3, 2)) - 1
				const year = Number(this.props.user.birthday.substr(6, 4))
				age = date.getFullYear() - year
				if (month > date.getMonth() || (month === date.getMonth() && day > date.getDate()))
					age--
			}
			this.state.user.age = age
			this.state.user.phone = this.props.user.phone
		}
	}

	componentDidMount() {
		const infos = {
			service: this.props.service
		}
		this.props.updateLogs(this.props.pathname, 'Services', infos)
		const sb = this.props.service_benefit
		if (sb && sb.questions && sb.questions.length > 0)
			this.setState({ answers: sb.questions.map(() => ''), step: 2 })
	}

	setErrorMsg = (msg) => {
		this.setState({ error: msg })
	}

	clearFlash = () => {
		this.setState({ error: null })
	}

	_initErrors = () => {
		const errors = {
			global: null,
			firstname: [],
			lastname: []
		}
		if (this.state)
		{
			for (let i = 0; i < this.state.form1.participants.length; i++)
			{
				errors.firstname.push(null)
				errors.lastname.push(null)
			}
		}
		return errors
	}

	goToBookingMenu = () => {
		this.setState({ step: 0 })
	}

	proceedFromRecap = () => {
		const cart = this.props.cart
		let price = 0
		for (let i = 0; i < cart.length; i++)
			price += Number(cart[i].price) * Number(cart[i].quantity)
		const service = this.props.service
		const hasExternalLink = typeof service.payment_link === 'string' && service.payment_link.length > 0
		// Paiement in-app selon le paramétrage du service : "cb_only" force le
		// checkout CB, "cb_optional" laisse le vacancier choisir CB ou sur place
		// (sauf seuils min/max qui imposent l'un ou l'autre), sinon (null/undefined,
		// gratuit ou lien de paiement externe) le paiement reste géré sur place.
		const payment_case = tools.getServicePaymentCase(service, price, hasExternalLink)
		if (payment_case === 'cb')
		{
			this._startCheckout()
			return
		}
		if (payment_case === 'choice')
		{
			this.setState({ payment_choice: true, stripeError: null })
			return
		}
		this._submitReservation()
	}

	choosePayNow = () => {
		this.setState({ payment_choice: false })
		this._startCheckout()
	}

	choosePayOnSite = () => {
		this.setState({ payment_choice: false })
		this._submitReservation()
	}

	// Paiement CB embarqué : crée le PaymentIntent puis ouvre le modal Checkout.
	// Si le camping n'est pas connecté à Stripe, on retombe sur le flux manuel.
	_startCheckout = () => {
		const reservation = this.state.reservation
		this.setState({ attempt_submit: true, stockError: null, stripeError: null })
		this.props.createServicePaymentIntent({
			service: reservation.service._id,
			cart: this.props.cart,
			client_number: this.state.user.client_number,
			user: reservation.user
		})
		.then(res => {
			if (res && res.client_secret)
			{
				this.setState({ checkout: res, attempt_submit: false })
				return
			}
			if (res && (res.error === 'account_not_ready' || res.error === 'stripe_not_configured' || res.error === 'below_minimum'))
			{
				this._submitReservation()
				return
			}
			this.setState({ attempt_submit: false, stripeError: this.props.lang_assets.services.payment.error_generic })
		})
		.catch(err => {
			this.setState({ attempt_submit: false, stripeError: this.props.lang_assets.services.payment.error_generic })
			console.log(err)
		})
	}

	handleAnswer = (event) => {
		const answers = [...this.state.answers]
		answers[this.state.question_nb] = event.target.value
		this.setState({ answers })
	}

	submitAnswer = (event) => {
		event.preventDefault()
		const { question_nb, answers } = this.state
		const question = this.props.service_benefit.questions[question_nb]
		if (question.mandatory === true && answers[question_nb].trim().length === 0)
		{
			this.setState({ error: { global: this.props.lang_assets.services.error_question } })
			return
		}
		this.setState({ error: null })
		if (question_nb + 1 < answers.length)
			this.setState({ question_nb: question_nb + 1 })
		else
		{
			const reservation = { ...this.state.reservation, answers: answers }
			this.setState({ reservation, step: 0, error: null })
		}
	}

	_submitReservation = (stripe_payment_intent_id = null) => {
		const reservation = {
			...this.state.reservation,
			cart: this.props.cart,
			client_number: this.state.user.client_number,
			identity: this.state.user.identity,
			age: this.state.user.age,
			phone: this.state.user.phone
		}
		if (stripe_payment_intent_id != null)
			reservation.stripe_payment_intent_id = stripe_payment_intent_id
		this.setState({ attempt_submit: true, stockError: null, stripeError: null, checkout: null })
		this.props.postServiceReservationCart(reservation)
		.then((res) => {
			const payment = this.props.lang_assets.services.payment
			if (res === false || (res && res.error === 'stock')) {
				this.setState({ attempt_submit: false, stockError: true })
				return
			}
			if (res && res.error === 'foreign_card') {
				this.setState({ attempt_submit: false, stripeError: payment.error_foreign_card })
				return
			}
			if (res && res.error === 'payment_required') {
				this.setState({ attempt_submit: false, stripeError: payment.error_payment_required })
				return
			}
			if (res && res.error) {
				this.setState({ attempt_submit: false, stripeError: payment.error_generic })
				return
			}
			this.setState({ step: 1, attempt_submit: false })
		})
		.catch(err => {
			this.setState({ attempt_submit: false })
			console.log(err)
		})
	}

	confirmBuying = () => {
		this.proceedFromRecap()
	}

	render() {
		const service = this.props.service
		const lang_assets = this.props.lang_assets.services
		const themeColor = '#' + this.props.theme.color1
		if (service)
		{
			if (this.state.step === 0) //RECAP
			{
				const reservation = this.state.reservation
				const start = new Date(reservation.start * 1000)
				let start_hour = start.getHours()
				if (start_hour < 10)
					start_hour = '0' + start_hour
				let start_minute = start.getMinutes()
				if (start_minute < 10)
					start_minute = '0' + start_minute
				const end = new Date(reservation.end * 1000)
				let end_hour = end.getHours()
				if (end_hour < 10)
					end_hour = '0' + end_hour
				let end_minute = end.getMinutes()
				if (end_minute < 10)
					end_minute = '0' + end_minute
				const time_assets = this.props.lang_assets.time
				const monthNames = time_assets.months
				const weekdays = time_assets.weekdays
				const weekday = weekdays[start.getDay()]
				let day = start.getDate()
				if (day < 10)
					day = '0' + day
				const monthName = monthNames[start.getMonth()]
				const year = start.getFullYear()
				let location = ""
				for (let i = 0; i < service.translations.length; i++)
				{
					if (service.translations[i].lang === this.props.user.lang)
					{
						location = service.translations[i].location
						break
					}
				}
				const cart = this.props.cart
				let price = 0
				for (let i = 0; i < cart.length; i++)
					price += Number(cart[i].price) * Number(cart[i].quantity)
				let price_txt = price.toFixed(2).replace('.', ',')
				const tarif = price > 0 ? price_txt + '€' : lang_assets.free

				const identityParts = (this.state.user.identity || "").trim().split(" ")
				const selfInitials = identityParts.map(p => p[0] || "").join("").slice(0, 2).toUpperCase()

				const hasExternalLink = typeof service.payment_link === 'string' && service.payment_link.length > 0
				const payment_case = tools.getServicePaymentCase(service, price, hasExternalLink)
				let confirm_label = lang_assets.button2
				if (payment_case === 'cb')
					confirm_label = lang_assets.button_cb
				else if (payment_case === 'choice')
					confirm_label = lang_assets.button_continue
				let buttonJSX = (
					<button type="button" onClick={this.proceedFromRecap} className="font-semibold py-4 w-full rounded-full text-white text-base waves-effect waves-light" style={{ backgroundColor: themeColor }}>
						{confirm_label}
					</button>
				)
				if (this.state.attempt_submit === true)
				{
					buttonJSX = (
						<div className="flex justify-center py-2">
							<Loader />
						</div>
					)
				}
				else if (typeof service.payment_link === 'string' && service.payment_link.length > 0)
				{
					buttonJSX = (
						<a href={service.payment_link} target="_blank" rel="noopener noreferrer">
							<button onClick={this.proceedFromRecap} type="button" className="font-semibold py-4 w-full rounded-full text-white text-base waves-effect waves-light" style={{ backgroundColor: themeColor }}>
								{lang_assets.button_pay}
							</button>
						</a>
					)
				}
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{lang_assets.check_before_confirm}</p>
							<h1 className="text-white text-2xl font-bold mt-1">{lang_assets.your_cart}</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl" style={{ paddingBottom: 'calc(var(--vh, 1vh) * 10 + 5rem)' }}>

							{/* Carte service + créneau */}
							<div className="mx-4 mt-6 rounded-2xl overflow-hidden shadow-sm border border-gray-100">
								<div className="px-5 py-4" style={{ backgroundColor: themeColor + "18" }}>
									<h2 className="text-xl font-bold" style={{ color: themeColor }}>{service.name}</h2>
									{location ? (
										<div className="flex items-center mt-1">
											<LocationMarkerIcon className="w-4 h-4 mr-1 flex-shrink-0" style={{ color: themeColor, opacity: 0.6 }} />
											<span className="text-sm" style={{ color: themeColor, opacity: 0.7 }}>{location}</span>
										</div>
									) : null}
								</div>
								<div className="border-t border-dashed border-gray-200" />
								<div className="px-5 py-4 bg-white">
									<div className="text-base font-medium text-gray-600 capitalize">{weekday} {day} {monthName} {year}</div>
									<div className="flex items-center gap-3 mt-3">
										<span className="text-2xl font-bold text-gray-800">{start_hour}:{start_minute}</span>
										<span className="text-gray-400 text-lg">→</span>
										<span className="text-2xl font-bold text-gray-800">{end_hour}:{end_minute}</span>
									</div>
								</div>
							</div>

							{/* Articles commandés */}
							<div className="mx-4 mt-6">
								<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">{lang_assets.your_order}</div>
								<div className="space-y-2">
									{cart.map(({ _id, translations, price: itemPrice, quantity }) => {
										let name = ""
										for (let i = 0; i < translations.length; i++)
										{
											if (translations[i].lang === this.props.user.lang)
											{
												name = translations[i].title || translations[i].subtitle || ''
												break
											}
										}
										if (!name && translations.length > 0)
											name = translations[0].title || translations[0].subtitle || ''
										const qty = Number(quantity)
										const p = Number(itemPrice)
										const lineFmt = p > 0 ? (p * qty).toFixed(2).replace('.', ',') + '€' : lang_assets.free
										const unitFmt = p > 0 ? p.toFixed(2).replace('.', ',') + '€' : null
										return (
											<div key={_id} className="rounded-xl bg-gray-50 px-4 py-3 flex items-start justify-between">
												<div className="flex-1 min-w-0">
													<div className="text-base font-medium text-gray-800">{qty}× {name}</div>
													{unitFmt && <div className="text-xs text-gray-400 mt-0.5">{unitFmt} {lang_assets.per_unit}</div>}
												</div>
												<div className="text-base font-semibold text-gray-800 ml-3">{lineFmt}</div>
											</div>
										)
									})}
								</div>
								{price > 0 && (
									<div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
										<span className="text-sm font-semibold text-gray-500">{lang_assets.total}</span>
										<span className="text-base font-bold" style={{ color: themeColor }}>{tarif}</span>
									</div>
								)}
							</div>

							{/* Identité */}
							<div className="mx-4 mt-6">
								<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">{lang_assets.your_account}</div>
								<div className="flex items-center gap-3 py-2">
									<div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: themeColor }}>{selfInitials}</div>
									<div className="text-base font-semibold text-gray-800">{this.state.user.identity}</div>
								</div>
							</div>

							{/* Réponses aux questions */}
							{this.state.answers.length > 0 && (() => {
								const sb = this.props.service_benefit
								const questionTitles = (sb && sb.questions ? sb.questions : []).map(q => {
									for (let i = 0; i < q.translations.length; i++)
										if (q.translations[i].lang === this.props.user.lang)
											return q.translations[i].title
									return q.translations[0] ? q.translations[0].title : ''
								})
								return (
									<div className="mx-4 mt-6">
										<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">{lang_assets.your_answers}</div>
										<div className="space-y-2">
											{this.state.answers.map((ans, i) => (
												<div key={i} className="rounded-xl bg-gray-50 px-4 py-3">
													<div className="text-xs text-gray-400">{questionTitles[i]}</div>
													<div className="text-base font-medium text-gray-800 mt-0.5">{ans || '—'}</div>
												</div>
											))}
										</div>
									</div>
								)
							})()}

							{this.state.stockError && (
								<div className="mx-4 mt-4 rounded-2xl bg-red-50 border border-red-200 px-4 py-3">
									<p className="text-sm font-medium text-red-600">{lang_assets.stock_error}</p>
									<button type="button" onClick={this.props.onEditCart}
										className="mt-2 text-sm font-semibold underline text-red-500">
										{lang_assets.edit_order}
									</button>
								</div>
							)}

							{this.state.stripeError && (
								<div className="mx-4 mt-4 rounded-2xl bg-red-50 border border-red-200 px-4 py-3">
									<p className="text-sm font-medium text-red-600">{this.state.stripeError}</p>
								</div>
							)}

							{/* Bouton fixe au-dessus du BottomBar */}
							<div className="fixed left-0 right-0 bg-white border-t border-gray-100 px-4 py-4" style={{ bottom: 'calc(var(--vh, 1vh) * 10)' }}>
								{buttonJSX}
							</div>

							{this.state.payment_choice && (
								<PaymentChoice
									assets={lang_assets.payment}
									themeColor={themeColor}
									amountLabel={tarif}
									onPayNow={this.choosePayNow}
									onPayOnSite={this.choosePayOnSite}
									onClose={() => this.setState({ payment_choice: false })}
								/>
							)}

							{this.state.checkout && (
								<Checkout
									publishable_key={this.state.checkout.publishable_key}
									client_secret={this.state.checkout.client_secret}
									themeColor={themeColor}
									amountLabel={tarif}
									lang={this.props.user.lang}
									assets={lang_assets.payment}
									onPaid={(payment_intent_id) => this._submitReservation(payment_intent_id)}
									onClose={() => this.setState({ checkout: null })}
								/>
							)}
						</div>
					</div>
				)
			}
			else if (this.state.step === 2 && this.state.answers.length > 0) //QUESTIONS
		{
			const { question_nb, answers } = this.state
			const sb = this.props.service_benefit
			const question = sb.questions[question_nb]
			let title = ""
			for (let i = 0; i < question.translations.length; i++)
			{
				if (question.translations[i].lang === this.props.user.lang)
				{
					title = question.translations[i].title
					break
				}
			}
			if (!title && question.translations.length > 0)
				title = question.translations[0].title
			const error = this.state.error ? this.state.error.global : null
			const errorHtml = error ? (
				<div className="flex items-center gap-2 mt-4 text-red-500 text-sm">
					<XCircleIcon className="h-5 w-5 flex-shrink-0" />
					<span>{error}</span>
				</div>
			) : null
			const qNum = question_nb + 1
			return (
				<div className="min-h-4/5-screen">
					<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36 px-6" style={{ backgroundColor: themeColor }}>
						<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{lang_assets.question} {qNum} / {answers.length}</p>
						<div className="flex gap-2 mt-3">
							{answers.map((_, i) => (
								<div key={i} className="rounded-full transition-all" style={{
									width: i === question_nb ? 20 : 8,
									height: 8,
									backgroundColor: i === question_nb ? 'white' : 'rgba(255,255,255,0.4)'
								}} />
							))}
						</div>
					</div>
					<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl pb-20">
						<form onSubmit={this.submitAnswer} className="px-6 pt-10">
							<h2 className="text-2xl font-bold text-gray-800 mb-8 leading-snug">
								{title}{question.mandatory ? <span className="text-red-400"> *</span> : null}
							</h2>
							{question.type === "number" ? (
								<input
									type="number"
									autoFocus
									className="date-field block w-full text-xl text-center py-5 px-4 border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
									onChange={this.handleAnswer}
									value={answers[question_nb]}
								/>
							) : (
								<textarea
									rows={5}
									autoFocus
									className="block w-full text-lg text-gray-700 py-4 px-4 border-2 border-gray-200 rounded-2xl focus:outline-none resize-none"
									value={answers[question_nb]}
									onChange={this.handleAnswer}
								/>
							)}
							{errorHtml}
							<button type="submit" className="font-semibold py-5 w-full rounded-full text-white shadow-xl text-base waves-effect waves-light mt-10" style={{ backgroundColor: themeColor }}>
								{lang_assets.button3}
							</button>
						</form>
					</div>
				</div>
			)
		}
		else if (this.state.step === 1) //CONFIRMATION FINALE
			{
				const bodymovinOptions = {
					loop: false,
					autoplay: true,
					prerender: true,
					animationData: animation
				}
				const resStart = new Date(this.state.reservation.start * 1000)
				const time_assets = this.props.lang_assets.time
				const monthNames = time_assets.months
				const weekdays = time_assets.weekdays
				const resWeekday = weekdays[resStart.getDay()]
				let resDay = resStart.getDate()
				if (resDay < 10) resDay = '0' + resDay
				const resMonthName = monthNames[resStart.getMonth()]
				let resHour = resStart.getHours()
				if (resHour < 10) resHour = '0' + resHour
				let resMin = resStart.getMinutes()
				if (resMin < 10) resMin = '0' + resMin
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{service.name}</p>
							<h1 className="text-white text-2xl font-bold mt-1">{lang_assets.confirmed}</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl px-6" style={{ paddingBottom: 'calc(var(--vh, 1vh) * 10 + 2rem)' }}>
							<div className="flex flex-col items-center pt-10">
								<div className="w-40">
									<ReactBodymovin options={bodymovinOptions} />
								</div>
								<h2 className="text-3xl font-bold mt-4" style={{ color: themeColor }}>{lang_assets.thanks}</h2>
								<p className="text-lg font-medium text-gray-500 mt-2 text-center">{lang_assets.confirm_msg}</p>
								<div className="mt-6 px-5 py-3 rounded-2xl bg-gray-50 w-full text-center">
									<p className="text-base font-semibold text-gray-800">{service.name}</p>
									<p className="text-sm text-gray-400 mt-0.5 capitalize">{resWeekday} {resDay} {resMonthName} · {resHour}:{resMin}</p>
								</div>
							</div>
							<div className="mt-8 flex flex-col gap-3">
								<Link to="/" className="block w-full text-center font-semibold py-4 rounded-full text-white text-base waves-effect waves-light" style={{ backgroundColor: themeColor }}>{lang_assets.back_home}</Link>
								<Link to="/membres/reservations" className="block w-full text-center font-semibold py-4 rounded-full text-base border-2 text-gray-600" style={{ borderColor: themeColor }}>{lang_assets.view_orders}</Link>
							</div>
						</div>
					</div>
				)
			}
			else
			{
				return (
					<div className="loading">
						<Loader />
					</div>
				)
			}
		}
		else
		{
			return (
				<div className="loading">
					<Loader />
				</div>
			)
		}
	}
}

export default Buying
